import LaboratoriaFull from 'marketing-website/components/icons/LaboratoriaFull';
import statsImage from 'marketing-website/media/images/pages/case-studies/laboratoria/stats@2x.jpg';
import image01a from 'marketing-website/media/images/pages/case-studies/laboratoria/image-01-a@2x.jpg';
import image01b from 'marketing-website/media/images/pages/case-studies/laboratoria/image-01-b@2x.jpg';
import image02a from 'marketing-website/media/images/pages/case-studies/laboratoria/image-02-a@2x.jpg';
import image02b from 'marketing-website/media/images/pages/case-studies/laboratoria/image-02-b@2x.jpg';
import image03 from 'marketing-website/media/images/pages/case-studies/laboratoria/image-03@2x.jpg';
import image03a from 'marketing-website/media/images/pages/case-studies/laboratoria/image-03-a@2x.jpg';
import image03b from 'marketing-website/media/images/pages/case-studies/laboratoria/image-03-b@2x.jpg';
import image04a from 'marketing-website/media/images/pages/case-studies/laboratoria/image-04-a@2x.jpg';
import image04b from 'marketing-website/media/images/pages/case-studies/laboratoria/image-04-b@2x.jpg';
import image05 from 'marketing-website/media/images/pages/case-studies/laboratoria/image-05@2x.jpg';

const laboratoriaAssets = {
  heroLogo: LaboratoriaFull,
  statsImage: {
    src: statsImage,
    srcSet: statsImage,
    maxWidth: 1290,
    alt: 'Laboratoria at ideation stage',
  },
  stats: [
    {
      id: 0,
      stat: '80%',
      title: 'employment success rate',
      copy:
        'Laboratoria hopes to increase their graduate employment success rate to 85%.',
    },
    {
      id: 1,
      stat: '800+',
      title: 'students',
      copy:
        'Since their launch in 2014 Laboratoria have taught more than 800 students in their program.',
    },
    {
      id: 2,
      stat: '200+',
      title: 'UX design graduates',
      copy:
        'since introducing their UX Design course in 2017, which uses Marvel.',
    },
  ],
  doubleImages: {
    first: [
      {
        src: image01a,
        maxWidth: 536,
        alt: 'Laboratoria plan projects',
      },
      {
        src: image01b,
        maxWidth: 550,
        alt: 'Laboratoria and Marvel App',
      },
    ],
    second: [
      {
        src: image02a,
        maxWidth: 556,
        alt: 'Laboratoria Study Sessions',
      },
      {
        src: image02b,
        maxWidth: 556,
        alt: 'Code Editor at Laboratoria',
      },
    ],
    third: [
      {
        src: image03a,
        maxWidth: 556,
        alt: 'planning and strategy',
      },
      {
        src: image03b,
        maxWidth: 556,
        alt: 'planning and strategy',
      },
    ],
    fourth: [
      {
        src: image04a,
        maxWidth: 556,
        alt: 'collaboration at Laboratoria with Marvel App',
      },
      {
        src: image04b,
        maxWidth: 556,
        alt: 'collaboration at Laboratoria with Marvel App',
      },
    ],
  },
  singleImages: {
    first: {
      src: image03,
      maxWidth: 1141,
      alt: 'team work at Laboratoria',
    },
    second: {
      src: image05,
      maxWidth: 1141,
      alt: 'team work at Laboratoria',
    },
  },
};

export default laboratoriaAssets;



// WEBPACK FOOTER //
// ./src/configs/caseStudies/laboratoria.js